import { BaseHttp as $http } from '../common/service';

export const SystemApi = {
  // 处理api数据
  handleApi: (data: any, config?: any) => {
    return $http.requestParams(data.serviceName, data.funcName, data.params, config);
  }
};
